import {Accordion, AccordionSummary, Typography, Button} from "@mui/material"
import {Warning as CaseEscalatedIcon} from "@mui/icons-material"
import React from "react"
import styled from "styled-components"
import {useNavigate} from "react-router-dom"

import {CustomerCaseEscalatedActivityPayload} from "@indebted/api"

function CaseEscalatedActivity(
	panelId: number,
	{Title, HappenedAt, Payload}: {Title: string; HappenedAt: string; Payload: CustomerCaseEscalatedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => void,
	classes: {summary: string},
	customerID: string,
) {
	const navigate = useNavigate()

	return (
		<AccordionNoContent expanded={false}>
			<AccordionSummary>
				<CaseEscalatedIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
				{Payload.CaseID && (
					<Button
						size="small"
						variant="outlined"
						onClick={() => navigate(`/customers/${customerID}/cases?CaseID=${Payload.CaseID}`)}
						sx={{textTransform: "none", fontSize: "0.75rem", fontWeight: 600, ml: 1}}
					>
						See Case
					</Button>
				)}
			</AccordionSummary>
		</AccordionNoContent>
	)
}

const AccordionNoContent = styled(Accordion)`
	.MuiAccordionSummary-content {
		cursor: default;
	}
`

export {CaseEscalatedActivity}
